import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import {Form, Field, Row, FileInput} from '@smartplatform/ui';
import store from '../../store';

@observer
export default class Edit extends React.Component {
	
	@observable record = null;
	@observable error = null;

	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.BaseLaw.findById(this.id);
			}
			catch(e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.BaseLaw();
		}
	};
	
	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;
		
		return <>
			<p>Базовый закон</p>
			<Form record={this.record} rootPath="/admin" returnTo="/admin/baselaws">
				<Field property="name" label="Наименование" />
				<Field property="number" label="Номер" />
				<Field property="date" label="Дата" />
				<Field property="author" label="Инициатор" />
				<Row>
					<Field property="filename" label="PDF-файл закона">
						<FileInput accept="application/pdf" />
					</Field>
				</Row>
			</Form>
		</>;
	}
	
}
